import { InputProps } from 'antd';

export const inputKtp = {
	maxLength: 16,
} as InputProps;
export const inputKitas = {
	maxLength: 11,
} as InputProps;
export const inputPassport = {
	maxLength: 9,
	minLength: 7,
} as InputProps;
